import { useEffect, useRef } from 'react';

/** Сканер штрихкодов для компьютера */
const Scan = ({onScan}) => {
  const lastKeyTimeRef = useRef(0);
  const inputBufferRef = useRef('');

  useEffect(() => {
    const handleKeyDown = (e) => {
      const currentTime = Date.now();
      const timeSinceLastKey = currentTime - lastKeyTimeRef.current;

      // Игнорируем сам Enter при проверке времени
      if (e.key !== 'Enter') {
        // Если время между нажатиями больше 50мс - это не сканер
        if (timeSinceLastKey > 50 && inputBufferRef.current.length > 0) {
          inputBufferRef.current = ''; // Сбрасываем буфер
        }
        
        // Добавляем символ в буфер
        inputBufferRef.current += e.key;
      }

      lastKeyTimeRef.current = currentTime;

      // Обработка завершения ввода (Enter)
      if (e.key === 'Enter' && inputBufferRef.current.length > 0) {
        // Проверяем, был ли ввод быстрым (как от сканера)
        const isLikelyScanner = inputBufferRef.current.length > 5; // Штрих-коды обычно длинные
        
        if (isLikelyScanner) {
          console.log('Штрих-код отсканирован:', inputBufferRef.current);          
          // Дополнительные действия с отсканированным кодом
          onScan(inputBufferRef.current);
        }
        
        // Сбрасываем буфер после обработки Enter
        inputBufferRef.current = '';
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [onScan]);
  return <div />
};

export default Scan;